import { html } from '@beunity/lit-components';
import BaseMenu from '@beunity/lit-components/components/base_menu/element.js';
import { StoreController } from '@beunity/lit-components/lib/lit/store_controller.js';
import {
  computedChatsStore,
  markAllAsRead,
} from '@beunity/lit-components/components/chat/lib/chats.store.js';

import '../icon/element.js';
import translations from './translations.js';

/**
 * Dot menu for chats index page
 *
 * @prop markAllAsReadOn - Should show "Mark all as read" action? (optional)
 * @prop markAllAsReadUrl - Url for "Mark all as read" action (optional)
 *
 * @slot trigger - For trigger (optional)
 */

export default class ChatsMenu extends BaseMenu {
  static properties = {
    markAllAsReadOn: { type: Boolean },
    markAllAsReadUrl: { type: String },
  };

  /** @internal */
  static translations = translations;

  /** @internal */
  storeController = new StoreController(this, computedChatsStore);

  /** @internal */
  get instanceId() {
    return 'chats-index';
  }

  /** @internal */
  get store() {
    return this.storeController.value;
  }

  /** @internal */
  get hasUnread() {
    return this.store.unreadCounters.all;
  }

  /** @internal */
  get markAllAsReadItem() {
    return {
      title: this.t('actions.mark_all_as_read'),
      action: this.actionFor('markAllAsRead'),
      icon: 'check-circle',
      partName: 'check',
    };
  }

  /** @internal */
  get items() {
    return [
      this.markAllAsReadOn && this.hasUnread && this.markAllAsReadItem,
    ].filter(Boolean);
  }

  /** @internal */
  get dotMenuConfig() {
    return {
      header: this.t('title'),
      buttons: this.items,
      showCancel: true,
    };
  }

  actionFor(method, args) {
    return {
      menu: 'bu-chats-menu',
      id: this.instanceId,
      method: method,
      ...(args && { args: args }),
    };
  }

  markAllAsRead() {
    if (!this.hasUnread) return;

    return markAllAsRead(this.markAllAsReadUrl);
  }

  render() {
    return html`
      <ef-dot-menu ?hidden=${!this.items.length} .config=${this.dotMenuConfig}>
        <slot name="trigger" slot="trigger">
          <button class="bu-btn btn-naked-dark">
            <bu-icon name="ellipsis-vertical"></bu-icon>
          </button>
        </slot>
      </ef-dot-menu>
    `;
  }
}

ChatsMenu.registerTagName('bu-chats-menu');
ChatsMenu.registerCommonActions('bu-chats-menu');

customElements.get('bu-chats-menu') ||
  customElements.define('bu-chats-menu', ChatsMenu);
